import { ContextApi } from 'contexts/Localization/types'
import { PageMeta } from './types'

export const DEFAULT_META: PageMeta = {
  title: 'AmpleSwap - The best AMM DEX on Binance Smart Chain (BSC)',
  description:
    'The most popular AMM on BSC by user count! Earn TEST through yield farming or win it in the Lottery, then stake it in Syrup Pools to earn more tokens! Initial Farm Offerings (new token launch model pioneered by AmpleSwap), NFTs, and more, on a platform you can trust.',
  image: 'https://ampleswap.com/images/ampleimg/twitter.png',
}

export const getCustomMeta = (path: string, t: ContextApi['t']): PageMeta => {
  switch (path) {
    case '/':
      return {
        title: `${t('Home')} | ${t('AmpleSwap')}`,
      }
    case '/competition':
      return {
        title: `${t('Trading Battle')} | ${t('AmpleSwap')}`,
      }
    case '/prediction':
      return {
        title: `${t('Prediction')} | ${t('AmpleSwap')}`,
      }
    case '/farms':
      return {
        title: `${t('Farms')} | ${t('AmpleSwap')}`,
      }
    case '/pools':
      return {
        title: `${t('Pools')} | ${t('AmpleSwap')}`,
      }
    case '/lottery':
      return {
        title: `${t('Lottery')} | ${t('AmpleSwap')}`,
      }
    case '/collectibles':
      return {
        title: `${t('Collectibles')} | ${t('AmpleSwap')}`,
      }
    case '/ifo':
      return {
        title: `${t('Initial Farm Offering')} | ${t('AmpleSwap')}`,
      }
    case '/teams':
      return {
        title: `${t('Leaderboard')} | ${t('AmpleSwap')}`,
      }
    case '/profile/tasks':
      return {
        title: `${t('Task Center')} | ${t('AmpleSwap')}`,
      }
    case '/profile':
      return {
        title: `${t('Your Profile')} | ${t('AmpleSwap')}`,
      }
    default:
      return null
  }
}
